import testerAccounts from '../constants/testerAccounts.json';

export const TESTER_ACCOUNTS = testerAccounts.accounts;

/** True for the QA accounts made by scripts/create-tester-accounts.cjs. */
export function isTesterUser(user) {
  return !!user && user.isTester === true;
}

/** Short badge text for the Admin users list, e.g. "Tester · Admin". */
export function testerBadgeLabel(user) {
  if (!isTesterUser(user)) return null;
  const spec = TESTER_ACCOUNTS.find((a) => a.role === user.testerRole);
  return spec ? spec.label : 'Tester';
}
